import {useEffect} from 'react';
import {useIsInViewPort} from "./useIsInViewPort";

export const useSwiperAutoPlayOnView = (
  swiperRef,
  containerRef,
  enabled = true
) => {
	const isInView = useIsInViewPort(containerRef, {threshold: 0.1}); // 0.1 = minimum 10% (1 = 100%) in viewport

	useEffect(() => {
		const swiperInstance = swiperRef.current?.swiper;
		if (!swiperInstance) {
			return;
		}

		if (!enabled) {
			swiperInstance.autoplay?.stop?.();
			return;
		}

		if (isInView) {
			swiperInstance.autoplay?.start?.();
		} else {
			swiperInstance.autoplay?.stop?.();
		}

		// cleanup on unmount
		return () => {
			swiperInstance.autoplay?.stop?.();
		};
	}, [isInView, enabled, swiperRef]);
};